import React, { FC } from "react";
import { Field } from "react-final-form";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import BootstrapInput from "../../../../../components/BootstrapInput";

const useStyles = makeStyles(() => ({
  mainLabel: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#535358",
    marginTop: 18,
  },
  container: {
    marginTop: 4,
  },
}));

interface IAccommodationFees {
  name: string;
  boardingRequired?: boolean;
  homestayRequired?: boolean;
}

export const AccommodationFees: FC<IAccommodationFees> = ({
  name,
  boardingRequired,
  homestayRequired,
}) => {
  const classes = useStyles();

  return (
    <div>
      <Typography className={classes.mainLabel}>Accommodation Fees</Typography>
      <Grid container spacing={3} className={classes.container}>
        <Grid item xs={12} sm={12} md={4}>
          <Field
            required={boardingRequired}
            disabled={!boardingRequired}
            placeholder={boardingRequired ? "Amount" : ""}
            fullWidth
            type="text"
            label="Room and Board"
            name={`${name}.boardingAmount`}
            component={BootstrapInput}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Field
            required={homestayRequired}
            disabled={!homestayRequired}
            placeholder={homestayRequired ? "Amount" : ""}
            fullWidth
            type="text"
            label="Homestay"
            name={`${name}.homestayAmount`}
            component={BootstrapInput}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Field
            fullWidth
            type="text"
            label="Insurance"
            placeholder="Amount"
            name={`${name}.insuranceAmount`}
            component={BootstrapInput}
          />
        </Grid>
      </Grid>
    </div>
  );
};
